"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _animations = require("./animations");

Object.keys(_animations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _animations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _animations[key];
    }
  });
});

var _theme = require("./theme");

Object.keys(_theme).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _theme[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _theme[key];
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/dist/styles/index.js
// module id = 108
// module chunks = 0 15 16 17 18